var styles = {"carouselButton":"carousel-buttons--carousel-button","buttonBack":"carousel-buttons--button-back","buttonNext":"carousel-buttons--button-next","circleChevronNext":"carousel-buttons--circle-chevron-next","circleChevron":"carousel-buttons--circle-chevron"};

export { styles as default };
//# sourceMappingURL=CarouselButtons.module.esm.js.map
